module.exports = __webpack_public_path__ + "img/loading.62ca374f.gif";